if (!customElements.get("s-hp-compare")) {
  customElements.define(
    "s-hp-compare",
    class SectionHPCompare extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.swiper = new Swiper(this, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          speed: 400,
          breakpoints: {
            560: {
              slidesPerView: 1.9,
            },
            768: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
            }
          }
        })
      }

      disconnectedCallback() {
      }
    }
  );
}
